import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const HeaderStyled = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1.6rem;
  border-bottom: 1px solid ${colors.neutral[300]};

  @media (width < 850px) {
    flex-wrap: wrap;
  }
`;

export const SectionTitleStyled = styled.h2`
  font-size: 1.5rem;
  line-height: 2.4rem;
  letter-spacing: 0.05rem;
  text-transform: uppercase;
  font-weight: 700;
  color: ${colors.neutral[900]};
  margin: 0 2rem 0 0;
`;
